import React, { Component } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

export class LogOn extends Component {
  constructor() {
    super();

    this.over = false;
    this.alreadyFocused = false;
    this.alreadyBlured = false;

    this.state = {
      hideList: true,
    };

    this.hideList = () => {
      this.setState({
        hideList: true,
      });
    };

    this.handleKeyDown = (e) => {
      if (e.keyCode === 9) {
        this.pressedTab = true;
      }
    };

    this.handleBlur = () => {
      if (!this.pressedTab) {
        if (this.over) {
          if (this.alreadyBlured) {
            this.alreadyBlured = false;
          } else {
            this.select.focus();
          }
        } else {
          this.hideList();
        }
      } else {
        this.pressedTab = false;
      }
    };

    this.handleClickClickable = (e) => {
      e.stopPropagation();

      if (this.alreadyFocused) {
        this.alreadyFocused = false;
      } else {
        this.alreadyBlured = true;
        this.hideList();
        this.select.blur();
      }
    };

    this.handleMouseOver = () => {
      this.over = true;
    };

    this.handleMouseOut = () => {
      this.over = false;
    };

    document.body.addEventListener("click", () => {
      if (!this.over) {
        this.hideList();
      }
    });

    this.handleFocus = () => {
      this.setState({
        hideList: false,
      });

      this.alreadyFocused = true;
    };

    this.handleAnchorBlur = () => {
      this.hideList();
    };
  }

  render() {
    const { className, label } = this.props;
    const { hideList } = this.state;

    return (
      <div
        className={`select-options${className ? ` ${className}` : ""}${
          hideList ? "" : " select-options--show"
        }`}
        ref={(ref) => {
          this.select = ref;
        }}
        tabIndex="0"
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
        onKeyDown={this.handleKeyDown}
        onFocus={this.handleFocus}
        title="Rozwiń lub zwiń dostępne funkcje"
      >
        <div
          className="select-options__clickable"
          onClick={this.handleClickClickable}
        >
          <div className="select-options__name" aria-hidden="true">
            {label}
            <i
              className="fa fa-angle-down select-options__icon"
              aria-hidden="true"
            />
          </div>
          <div className="select-options__selected" aria-hidden="true" />
        </div>
        <div className="select-options__shadow" />
        <ul className="select-options__list">
          <li className="select-options__element">
            <NavLink
              className="select-options__link select-options__link--has-icon"
              to="/konto"
              title={`Przejdź do ustawień konta`}
            >
              <i
                class="fa fa-cog select-options__element-icon"
                aria-hidden="true"
              ></i>
              <span aria-hidden="true">Ustawienia konta</span>
            </NavLink>
          </li>
          <li className="select-options__element">
            <a
              className="select-options__link select-options__link--has-icon"
              onBlur={this.handleAnchorBlur}
              onClick={this.props.onLogout}
              title={`Wyloguj z systemu`}
            >
              <i
                className="fas fa-power-off select-options__element-icon"
                aria-hidden="true"
              />
              <span aria-hidden="true">Wyloguj</span>
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

LogOn.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  onLogout: PropTypes.func,
};

LogOn.defaultProps = {
  className: "",
  label: "",
  onLogout: Function.prototype,
};
